import styled from 'styled-components';
import { ReachTab } from 'components/Reach';
import BaseButton from 'components/Button';
import HelperText from 'components/HelperText';
import {
  Header as BaseHeader,
  Dialog as BaseDialog,
  Body as BaseBody,
} from 'components/Modal';
import {
  calculateTitlePadding,
  calculateTabPadding,
  calculateButtonPadding,
} from './utils/loginModal.utils';

export const CustomHelperText = styled(HelperText)`
  display: block;
  margin-top: 10px;
`;

/**
 * LoginModal-specific Header with dynamic font size and padding
 * Extends the base Modal Header without affecting other modals
 */
export const LoginModalHeader = styled(BaseHeader)`
  font-size: ${({ theme }) =>
    theme.configs?.styling?.searchForm?.titleFontSize || 14}px;
  line-height: 1.2;
  padding: ${({ theme }) => {
    const fontSize = theme.configs?.styling?.searchForm?.titleFontSize || 14;
    return calculateTitlePadding(fontSize);
  }}px;
`;

/**
 * LoginModal-specific Dialog (extends base if needed for future customization)
 */
export const LoginModalDialog = styled(BaseDialog)`
  /* Inherits all base styles, can be extended if needed */
`;

/**
 * LoginModal-specific Body (extends base if needed for future customization)
 */
export const LoginModalBody = styled(BaseBody)`
  /* Inherits all base styles, can be extended if needed */
`;

/**
 * LoginModal-specific Tab with dynamic font size and padding
 * Used for search type tabs (tracking number, order ID, etc.)
 */
export const LoginSearchTab = styled(ReachTab)`
  display: flex;
  overflow: hidden;
  flex: 1;
  justify-content: center;
  margin-bottom: -2px;
  padding: ${({ theme }) => {
      const fontSize = theme.configs?.styling?.searchForm?.tabFontSize || 14;
      return calculateTabPadding(fontSize);
    }}px
    10px;
  color: ${({ theme }) => theme.configs.tertiaryBox.secondaryFontColor};
  font-size: ${({ theme }) =>
    theme.configs?.styling?.searchForm?.tabFontSize || 14}px;
  line-height: 1.2;
  font-weight: bold;
  cursor: pointer;

  /* Apply active styles when has data-selected attribute (generated by Reach) */
  &[data-selected] {
    color: ${({ theme }) => theme.configs.tertiaryBox.mainFontColor};
    border-bottom: ${({ theme }) =>
      `3px solid ${theme.configs.tertiaryBox.mainFontColor}`};
  }
`;

/**
 * LoginModal-specific Button with dynamic font size, padding, and alignment
 * Used for the search/submit button
 * Supports left, center (default), and right alignment
 */
export const LoginSearchButton = styled(BaseButton)`
  display: block;
  width: auto;
  min-width: 170px;
  height: auto;
  padding: ${({ theme }) => {
      const fontSize = theme.configs?.styling?.searchForm?.buttonFontSize || 12;
      return calculateButtonPadding(fontSize);
    }}px
    16px;
  font-size: ${({ theme }) =>
    theme.configs?.styling?.searchForm?.buttonFontSize || 12}px;
  line-height: 1.2;
  margin-left: ${({ theme }) => {
    const alignment =
      theme.configs?.styling?.searchForm?.buttonAlignment || 'center';
    if (alignment === 'left') return '0';
    if (alignment === 'right') return 'auto';
    return 'auto'; // center
  }};
  margin-right: ${({ theme }) => {
    const alignment =
      theme.configs?.styling?.searchForm?.buttonAlignment || 'center';
    if (alignment === 'left') return 'auto';
    if (alignment === 'right') return '0';
    return 'auto'; // center
  }};
`;
